import React from "react";

const CreateGroupError = ({ setCreateError, errorMessage }) => {
  return (
    <>
      <div className=" successful_preview_transprant_body ">
        <div className=" p-2 successful_preview_container shadow">
          {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
          <img className="prereadLoader" src="/images/alert.svg" alt="" />
          <span className=" mb-4 mt-2 successfully_message">
            <p> 
          {errorMessage === "Provieded group name already exist in our database."? "A group already exists with this name. Please select a different name.": errorMessage}
            </p>
          </span>
          <button
            className="successfull_okay_btn"
            onClick={() => {
                setCreateError(false);
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </>
  );
};

export default CreateGroupError;
